import React from "react";
import clsx from "clsx";

import Typography from "@material-ui/core/Typography";

import format from "date-fns/format";
import isAfter from "date-fns/isAfter";
import endOfYesterday from "date-fns/endOfYesterday";
import parseISO from "date-fns/parseISO";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import ScheduleMiniBox from "./ScheduleMiniBox";

import useStyles from "./styles";

export interface Props {
  schedule: racehorse360.IWorkout[];
  className: string;
}

const mapDates = (schedule: racehorse360.IWorkout[]) => {
  return schedule.reduce((acc, cur) => {
    const monthName = format(parseISO(cur.date), "MMM").toUpperCase();
    acc[monthName] = acc[monthName] || [];
    acc[monthName].push(cur);
    return acc;
  }, {});
};

const ScheduleHeaderPreview = React.memo((props: Props) => {
  const { className, schedule } = props;
  const classes = useStyles();

  const futureDates = schedule.filter(workout =>
    isAfter(parseISO(workout.date), endOfYesterday())
  );
  const miniSchedule = mapDates(futureDates.slice(0, 4));
  const miniScheduleKeys = Object.keys(miniSchedule);

  return (
    <div className={clsx(className, classes.container)}>
      {miniScheduleKeys.map(month => {
        return (
          <div key={month} className={classes.month}>
            <Typography className={classes.monthName}>{month}</Typography>
            {miniSchedule[month].map((workout: racehorse360.IWorkout) => (
              <ScheduleMiniBox
                key={
                  workout.facility.id + "-" + parseISO(workout.date).getTime()
                }
                date={workout.date}
                facility={workout.facility}
              />
            ))}
          </div>
        );
      })}
      {futureDates.length > 4 && (
        <span className={classes.dateEllipsis}>...</span>
      )}
    </div>
  );
});

export default ScheduleHeaderPreview;
